module.exports = __webpack_public_path__ + "static/media/brief-2.da5de435.svg";